import { ISubscription, IAccount } from '../interfaces/graph-types';
import {
  map,
  catchError,
  startWith,
  first,
  take,
  distinctUntilChanged,
  filter,
} from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Apollo, gql } from 'apollo-angular-boost';
import { Injectable } from '@angular/core';
//import { query } from '@angular/core/src/render3/query';

type SuccessCallback = (data: any) => any;
type ErrorCallback = (err: string) => any;

@Injectable()
export class SubscriptionService {
  // ------------------------------------------------------
  constructor(private apollo: Apollo) {}

  // ------------------------------------------------------
  public queryGraphQL(query, variables): Observable<any> {
    return this.apollo.watchQuery<any>({
      variables: variables,
      query: query,
      fetchPolicy: 'cache-and-network',
      notifyOnNetworkStatusChange: false,
    }).valueChanges;
  }

  // ------------------------------------------------------
  public subscription(accountId: string): Observable<IAccount> {
    let variables = { accountId };

    let query = gql`
      query getSubscriptionInfor($accountId: ID!) {
        account(accountId: $accountId) {
          id
          disabledAt
          expiredAt
          customPricing
          subscription {
            id
            name
            cycle
            quantity
            status
            canceledAt
          }
        }
      }
    `;

    return this.queryGraphQL(query, variables).pipe(
      filter(response => response.data),
      map(({ data }) => data.account),
    );
  }

  // ------------------------------------------------------
  public updateSubscription(
    accountId: string,
    quantity: number,
    plan: string,
    billingInterval: string,
    successfunction: SuccessCallback,
    errorfunction: ErrorCallback,
  ) {
    const input = {
      accountId,
      quantity,
      plan,
      billingInterval,
    };

    this.apollo
      .mutate({
        mutation: gql`
          mutation updateSubscription(
            $input: UpdateSubscriptionInput!
          ) {
            updateSubscription(input: $input) {
              error
            }
          }
        `,
        variables: { input: input },
      })
      .pipe(
        catchError(err => {
          console.log('DAT ERROR');
          if (errorfunction) {
            errorfunction(err);
          }
          return null;
        }),
      )
      .subscribe(result => {
        let data = result['data'].updateSubscription;
        if (data['error']) {
          if (errorfunction) {
            console.error(data['error']);
            errorfunction(data['error']);
          }
          return null;
        }

        if (successfunction) {
          successfunction(data);
        }
        return null;
      });
    return null;
  }
}
